import { Component, Inject, Input, OnChanges, Optional, SimpleChanges } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DomSanitizer } from '@angular/platform-browser';
import { marked } from 'marked';
declare const $: any;

@Component({
	selector: 'app-email-summary-modal',
	templateUrl: './email-summary-modal.component.html',
	styleUrl: './email-summary-modal.component.scss'
})
export class EmailSummaryModalComponent implements OnChanges {
	@Input() rma_case: any = null;
	getRandom5DigitNumber() {
		return Math.floor(Math.random() * 90000) + 10000;
	}
	modalId = "emailSummaryModal" + this.getRandom5DigitNumber();
	constructor(private sanitizer: DomSanitizer, private toastr: ToastrService) { }

	ngOnChanges(changes: SimpleChanges): void {
		if (changes && changes.rma_case && changes.rma_case.currentValue) {
			this.rma_case.email_summary = this.cleanMailSummaryHtml(this.rma_case.email_summary || "");
			this.modalId = "emailSummaryModal" + /* this.getRandom5DigitNumber() + */ changes.rma_case.currentValue.case_id;
		}
	}

	openModal() {
		if (this.rma_case && this.rma_case.email_summary) {
			$("#" + this.modalId).modal("show");
		} else {
			this.toastr.warning("Email summary not found", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
		}
	}

	cleanMailSummaryHtml(content: string) {
		if (!content) return '';
		content = content.replace(/^(\d+)\./gm, '$1\\.');
		const match = content.match(/```(?:html)?\s*([\s\S]*?)\s*```/i);
		content = match ? match[1].trim() : content;
		const html = marked.parse(content) as string;
		const line_height = "line-height:0.9;";
		const cleanedHtml = html
			.replace(/<p>/g, '')
			.replace(/<\/p>/g, '');
		const styledHtml = cleanedHtml.replace(/<([a-z][a-z0-9]*)\b([^>]*)>/gi, (match, tag, attrs) => {
			let extraStyles = 'margin:0 !important;padding:0 !important;' + line_height;
			if (tag === 'ul' || tag === 'ol') {
				extraStyles += 'padding-left:16px !important;';
			}
			if (tag === 'li') {
				extraStyles += 'margin-bottom:2px !important;';
			}
			if (/^h[1-6]$/.test(tag) && !/margin-top/i.test(attrs)) {
				extraStyles += 'margin-top:10px !important;';
			}
			if (/style\s*=/.test(attrs)) {
				return `<${tag}${attrs.replace(/style\s*=\s*["']([^"']*)["']/i,
					(m, styles) => `style="${styles};${extraStyles}"`)}>`;
			}
			return `<${tag}${attrs} style="${extraStyles}">`;
		});
		return this.sanitizer.bypassSecurityTrustHtml(styledHtml);
	}
}
